import styled from 'styled-components'
import { Icon } from '../Icons'

export default styled(Icon)`
  font-size: 14px;
  color: ${props => props.theme.table.editButtonColor};
`
